import typeToReducer from 'type-to-reducer';

import * as actions from '../actions';

const iniState = {
  feesData: null,
  feesFailed: false,
  feesLoading: false,
  feesSucceeded: false
};

export const fees = typeToReducer(
  {
    [actions.CALCULATE_FEES]: {
      PENDING: (state, action) => ({
        ...state,
        feesData: null,
        feesLoading: true,
        feesFailed: false,
        feesSucceeded: false
      }),
      REJECTED: (state, action) => {
        return {
          ...state,
          feesData: action.payload ? action.payload.data : null,
          feesLoading: false,
          feesFailed: true,
          feesSucceeded: false
        };
      },
      FULFILLED: (state, action) => {
        return {
          ...state,
          feesData: action.payload ? action.payload.data : null,
          feesLoading: false,
          feesFailed: false,
          feesSucceeded: true
        };
      }
    },
    [actions.CLEAR_FORM]: () => ({
      ...iniState
    })
  },
  iniState
);
